/* import __COLOCATED_TEMPLATE__ from './switch-route-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();